export default {"src":"/_next/static/media/home.813f2ef0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};